import { GetScore, Lifter, Meet } from "types";
import { toKg } from "util/conversions";
import { getTotal } from "util/lifterHelper";
import { isLbsMeet } from "util/meetHelper";
import { ageCoef } from "./age";

const params = {
  MALE: {
    a: 47.4617885411949,
    b: 8.47206137941125,
    c: 0.073694103462609,
    d: -0.00139583381094385,
    e: 0.00000707665973070743,
    f: -0.0000000120804336482315,
  },
  FEMALE: {
    a: -125.425539779509,
    b: 13.7121941940668,
    c: -0.0330725063103405,
    d: -0.0010504000506583,
    e: 0.00000938773881462799,
    f: -0.000000023334613884954,
  },
};

//Wilks points = Total*600/(a+b*BW+c*BW^2+d*BW^3+e*BW^4+f*BW^5)
export const wilks2020Coef = function (lifter: Lifter, meet: Meet) {
  let bodyWeight = lifter.bodyWeight;

  if (isLbsMeet(meet)) {
    bodyWeight = toKg(bodyWeight);
  }

  const gender = lifter.gender;

  if (!bodyWeight || !gender) {
    return 0;
  }

  if (gender === "MX") {
    return 0;
  }

  const p = params[gender];

  return (
    500.0 /
    (p.a +
      p.b * bodyWeight +
      p.c * Math.pow(bodyWeight, 2) +
      p.d * Math.pow(bodyWeight, 3) +
      p.e * Math.pow(bodyWeight, 4) +
      p.f * Math.pow(bodyWeight, 5))
  );
};

export const getWilks2020Points: GetScore = ({
  lifter,
  division,
  meet,
  forecasted,
}) => {
  let total = getTotal({ lifter, division, meet, forecasted });
  if (isLbsMeet(meet)) {
    total = toKg(total);
  }

  return total * wilks2020Coef(lifter, meet);
};

export const getWilks2020AndAgePoints: GetScore = ({
  lifter,
  division,
  meet,
  forecasted,
}) => {
  return (
    getWilks2020Points({ lifter, division, meet, forecasted }) *
    ageCoef(lifter, meet)
  );
};
